export const params = {
  viewBoxMobile: {
    start: [1055, 100, 428, 929],
    end: [1055, 398, 428, 178],
  },
  viewBoxDesktop: {
    start: [0, 0, 2500, 929],
    end: [0, 371, 2500, 227],
  },
  markers: [
    {
      id: 'egypt',
      text: 'EGYPT',
      params: {
        mobile: {
          text: [1161, 491],
          marker: [1191, 465],
          line: 'M1208 431L1191 465',
        },
      },
    },
    {
      id: 'libanon',
      text: 'LIBANON',
      params: {
        mobile: {
          text: [1226, 418.18],
          marker: [1215, 412],
          line: 'M1208 431L1215 412',
        },
      },
    },
    {
      id: 'saudi',
      text: 'SAUDI-ARABIA',
      params: {
        mobile: {
          text: [1290, 497],
          marker: [1275, 490],
          line: 'M1208 431L1275 490',
        },
      },
    },
    {
      id: 'iran',
      text: 'IRAN',
      params: {
        mobile: {
          text: [1346, 438],
          marker: [1334, 431],
          line: 'M1208 431L1334 431',
        },
      },
    },
    {
      id: 'jemen',
      text: 'JEMEN',
      params: {
        mobile: {
          text: [1315, 565],
          marker: [1302, 558],
          line: 'M1208 431L1302 558',
        },
      },
    },
    {
      id: 'gaza',
      text: 'GAZA',
      params: {
        mobile: {
          text: [1156, 437],
          marker: [1208, 431],
        },
      },
    },
  ],
}
